import React from 'react';
import { useNavigate } from 'react-router-dom';
import api  from '@/shared/api/api';
import { AdminLayout } from '@/components/Layout/Layout';
import ProjectForm from './forms/ProjectForm';
import Button from '@/shared/ui/Buttons/Button';


function ProjectCreate() {
    const navigate = useNavigate();
    const onSubmit = (data: any) => {api.projects.createProjectsApiProjectsPost(data).then(()=>navigate("/projects"))}
    return (
        <AdminLayout>
            <div className='FormRow'>
                <Button onClick={() => navigate(-1)} style={{maxWidth: "100px"}}>Назад</Button>
                <h1 className='text-30'>Создание проекта</h1>
            </div>
            <ProjectForm defaultData={{}} onSubmit={onSubmit} />
        </AdminLayout>
    )
}

export default ProjectCreate;